import axios, { AxiosError } from 'axios';
import { UseQueryOptions, useQuery } from 'react-query';

import { Attribute } from '~/types/models';
import { DefaultGetAllResponse } from './rest';

export const queryKeys = {
  all: ['attributes'] as const,
  details: () => [...queryKeys.all, 'details'] as const,
  detail: (greetId: string, profileId?: string) =>
    [...queryKeys.details(), greetId, profileId] as const,
};

export type AttributeResponse = DefaultGetAllResponse<Attribute> & {
  profile_was_updated: boolean;
  automation_id: string;
};
export interface UseAttributesParams {
  greetId: string;
  profileId?: string;
  options?: UseQueryOptions<AttributeResponse, AxiosError>;
}

export async function fetchAttributes({
  greetId,
  profileId,
}: UseAttributesParams) {
  const res = await axios.get<AttributeResponse>('/api/v2/attributes', {
    params: {
      greet_id: greetId,
      profile_id: profileId,
    },
  });

  return res.data;
}

export function useAttributes({
  greetId,
  profileId,
  options,
}: UseAttributesParams) {
  return useQuery<AttributeResponse, AxiosError>(
    queryKeys.detail(greetId, profileId),
    () => fetchAttributes({ greetId, profileId }),
    options
  );
}
